import { clearConversationAction } from '../../actions/ai';
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'

type ClearConversationProps = {
  filename: string
  clearConversationUrl?: string
  showToast: boolean
  setshowSteps: React.Dispatch<React.SetStateAction<boolean>>
};

const clearConversation = async ({
  filename,
  clearConversationUrl,
  showToast = true,
  setshowSteps
}: ClearConversationProps) => {
  try {
    const formattedFilename = filename.replace(/ /g, '_')
    const result = await clearConversationAction(formattedFilename, clearConversationUrl);

    if (showToast) toast.success(result.message);
    setshowSteps(false);
  } catch (err) {
    if (err instanceof AxiosError) {
      toast.error(err.response?.data.message ?? err.message);
    }
    return Promise.reject(err);
  }
};

export default clearConversation;